import Dropdown from 'react-bootstrap/Dropdown';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HomeButton from './../HomeButton/index';

import styles from './HeaderUserDropDown.module.scss';
import { useNavigate } from 'react-router-dom';

const HeaderUserDropDown = ({ userData, logoutUser }) => {
  const { modelEspecifico } = userData;
  const name = modelEspecifico?.nombrePrestador.toLowerCase();
  const lastName = modelEspecifico?.apellidoPrestador.toLowerCase();
  const fullName = `${capitalizeFirstLetter(name)} ${capitalizeFirstLetter(lastName)}`;

  const navigate = useNavigate();

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <div className='text-white d-flex flex-inline align-items-center'>
      <FontAwesomeIcon icon={faUser} />
      <Dropdown className={styles.menuZIndex} data-test-id='user-dropdown'>
        <Dropdown.Toggle className={styles.header_user_drop_down__dropdown} id='dropdown-basic'>
          {screen.width < 490
            ? fullName.length >= 21
              ? modelEspecifico?.nombrePrestador
              : fullName
            : fullName}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => navigate(`/tramitesonline/datos-personales`)}
            data-test-id='user-dropdown-my-data'
          >
            Mis datos
          </Dropdown.Item>
          <Dropdown.Item onClick={logoutUser}>Cerrar Sesión</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <HomeButton />
    </div>
  );
};

export default HeaderUserDropDown;
